import api from '../api';
import { formatPrintedHtml } from './printerUtils';

export async function fetchDataToPrint(payload) {
  const response = await api
    .post('/restaurants/printers/printable-object-data', payload)
    .then((resp) => {
      const formattedHtml = formatPrintedHtml(resp.data.htmlToPrint);
      return formattedHtml;
    })
    .catch((error) => {
      throw error;
    });
  return response;
}
